import axios from "axios";

const state = {
  chatActive: false,
  chatReady: false,
  mods: [],
  admins: [],
  chatMode: false,
  addressBookReady: false,
  chatInterval: false,
  dialogues: [],
  user_dialogues: [],
  activeChats: [],
  activeChatUsers: [],
  customerDialogue: false,
  updateMessageIntervalTime: 10000,
  userAddressBook: {},
  userAvatars: [],
  unseenMessages: 0,
  defaultAvatar: 1193,
  defaultAvatarUrl: false, 
  customerAvatarsLoaded: false
};

const getters = {
  user_dialogues: (state) => state.user_dialogues,
  userAddressBook: (state) => state.userAddressBook,
  chatActive: (state) => state.chatActive,
  dialogues: (state) => state.dialogues,
  chatReady: (state) => state.chatReady,
  addressBookReady: (state) => state.addressBookReady,
  activeChats: (state) => state.activeChats,
  activeChatUsers: (state) => state.activeChatUsers,
  avatars: (state) => state.userAvatars,
  unseenMessages: (state) => state.unseenMessages,
  mods: (state) => state.mods,
  chatMode: (state) => state.chatMode,
  customerDialogue: (state) => state.customerDialogue,
  defaultAvatarUrl: (state) => state.defaultAvatarUrl,
  customerAvatarsLoaded: (state) => state.customerAvatarsLoaded,
  admins: (state) => state.admins
};

const actions = {
  async getAdminSubscribers({commit}) {
    try {      
      const queryAdmins = {
        filter: {
          status: "active",
          role: 1
        },
        limit: "-1"
      }
      const getAdmins = await this._vm.$directus.getItems("directus_users", queryAdmins);
      const adminSubscribers = getAdmins.data.filter(adm => {   
          
        return state.mods.find(mod => mod.user.id == adm.id) == undefined;         
      });
      commit("setAdmins", adminSubscribers);
    } catch(err) {
      console.log(err);
      throw "Error getting Infrabau Subscribers";
    }
  },
  async createKundeDialogue(_, kundeUser) {
    try {
      const hasDialogue = state.dialogues.find((d) => {
        return d.kunde.id == kundeUser;
      });

      //bail if dialogue exists
      if (typeof hasDialogue === "object") {
        return;
      }

      const createPayload = {
        kunde: kundeUser,
      };
      await this._vm.$directus.createItem("dialogue", createPayload);
    } catch (err) {
      console.log(err);
      throw "Error in createKundeDialogue";
    }
  },
  async getMods({ commit }) {
    try {
      const responseMods = await this._vm.$directus.getItems("moderator", { fields: "*.*" });
      commit("setMods", responseMods.data);
    } catch (err) {
      throw "Error getting Mods.";
    }
  },
  async isMod(_, usr) {
    const isMod = state.mods.find((m) => m.id == usr.id);
    return isMod !== undefined;
  },
  async setMod({ dispatch }, user) {
    this._vm.$directus.createItem("moderator", { user: user.id });
    await dispatch("getMods");
  },
  async unsetMod({ dispatch }, user) {
    const deleteId = state.mods.find((m) => m.user.id == user.id);
    await this._vm.$directus.deleteItem("moderator", deleteId.id);
    await dispatch("getMods");
  },
  checkSeenForAll({ rootState, commit }) {
    commit("setDefaultUnseen");
    if (!state.dialogues) return;
    state.activeChats.forEach(function(dialogue) {
      if (!dialogue.seenby) return;
      if (
        !dialogue.seenby.find((d) => {
          return d == rootState.auth.user.id;
        })
      ) {
        commit("incrementUnseen");
      }
    });
  },
  async initChat({ commit, dispatch }) {
    if (!state.chatActive) {
      await dispatch("startIntervalChat");
      commit("chatOn");
    }
  },
  async setChatMode({ commit, dispatch, rootState }) {
    await dispatch("getMods");
    const user = rootState.auth.user;

    if (user.role == 3) {
      commit("setChatMode", "customer");
      return;
    }

    if (user.role == 1) {
      if (state.mods.find((m) => m.user.id == user.id) !== undefined) {
        commit("setChatMode", "moderator");
        return;
      }

      commit("setChatMode", "subscriber");
    }
  },
  shutdownChat({ commit, dispatch }) {
    dispatch("stopIntervalChat");
    commit("chatOff");
  },
  async startIntervalChat({ commit, dispatch }) {
    if (state.chatActive == false) {
      try {
        if (!state.chatMode) await dispatch("setChatMode");
        if (!state.defaultAvatarUrl) await dispatch("getDefaultAvatarUrl");
        await dispatch("updateDialogues");
        await dispatch("getUserDialogues");
        commit("setChatReady");
        let interval = setInterval(async function() {
          await dispatch("updateDialogues");
          await dispatch("getUserDialogues");
        }, state.updateMessageIntervalTime);
        commit("setChatInterval", interval);
      } catch (error) {
        console.log(error);
        if (state.chatReady) commit("unsetChatReady");
        throw "Fehler beim laden des Nachrichtensystems";
      }
    }
  },
  stopIntervalChat() {
    clearInterval(state.chatInterval);
  },
  async setupChat({ dispatch }) {
    switch (state.chatMode) {
      case "customer":
        await dispatch("setupCustomerChat");
        break;
      case "moderator":
        await dispatch("setupModeratorChat");
        break;
      case "subscriber":
        await dispatch("setupSubscriberChat");
        break;
    }
  },
  async setupCustomerChat() {
    console.log("setupCustomerChat called");
  },
  async setupModeratorChat() {
    console.log("seutpModeratorChat called");
  },
  async setupSubscriberChat() {
    console.log("setupSubscriberChat called");
  },
  async updateDialogues({ dispatch }) {
    if (state.chatMode === "subscriber") await dispatch("updateChat");
    if (state.chatMode === "moderator") await dispatch("updateChat");
    if (state.chatMode === "customer") await dispatch("updateCustomerChat");
  },
  async updateChat({commit}) {
    try {
      const query = {
        fields: "*.*",
        limit: "-1",
      };
      const response = await this._vm.$directus.getItems("dialogue", query);
      commit("setDialogues", response.data);
    } catch (error) {
      console.log(error);
      throw "Error loading Dialogue Data";
    }
    return;
  },
  async updateCustomerChat({ rootState, commit, dispatch }) {
    try {
      const query = {
        filter: {
          kunde: rootState.auth.user.id,
        },
        fields: "*.*",
        limit: "-1",
      };
      const response = await this._vm.$directus.getItems("dialogue", query);
      commit("setDialogues", response.data); 
      await dispatch("updateCustomerAvatars");     
    } catch (err) {
      console.log(err);
      throw "Error loading Customer Chat Data";
    }
  },
  /** 
  * @description 
  * - checks if the avatar for the user is defined. 
  * - if no avatar is defined, the avatar image is loaded and saved in state.userAvatars
  * - if the avatar for the user is already in state.userAvatars, the function will bail    
  * - this function loads by a mod checked in Users dynamically 
  */
  async updateCustomerAvatars({commit}) {
    console.log("running updateCustomerAvatars");    
    //load the Avatar for the customer
    state.activeChats.forEach(async ac => {
      const chatObject = state.dialogues.find(d => d.id == ac.chat_id);
      const avatarLoaded = state.userAvatars.find(a => a.user == chatObject.kunde.id);

      if(avatarLoaded != undefined) {
        return;
      }
      
      try {        
        if (chatObject.kunde.avatar == undefined) {
          const avatar = {
            user: chatObject.kunde.id,
            first_name: chatObject.kunde.first_name,
            last_name: chatObject.kunde.last_name,
            avatar: state.defaultAvatarUrl
          }
          commit("addLoadedAvatar", avatar);          
        } else {
          const getAvatarOfUser = await this._vm.$directus.getItem("directus_files", chatObject.kunde.avatar);

          const avatar = {
            user: chatObject.kunde.id, 
            first_name: chatObject.kunde.first_name,
            last_name: chatObject.kunde.last_name,
            avatar: getAvatarOfUser.data.data.full_url
          }
          commit("addLoadedAvatar", avatar);
        }
      } catch(err) {
        console.log(err);
        throw "Error loading Avatar in updateCustomerAvatars";
      }
    }); 

    //load the avatars for all subscribers
    state.activeChatUsers.forEach( async u => {      
      const avatarLoaded = state.userAvatars.find(a => a.user == u.usr_id);
      if(avatarLoaded != undefined) {
        return;
      }

      try {        
        if (u.avatar == undefined) {
          const avatar = {
            user: u.usr_id,
            first_name: u.user.first_name,
            last_name: u.user.last_name,
            avatar: state.defaultAvatarUrl
          }
          commit("addLoadedAvatar", avatar);
        } else {
          const getAvatarOfUser = await this._vm.$directus.getItem("directus_files", u.avatar);
          const avatar = {
            user: u.usr_id, 
            first_name: u.user.first_name,
            last_name: u.user.last_name,
            avatar: getAvatarOfUser.data.data.full_url
          }
          commit("addLoadedAvatar", avatar);
        }
      } catch(err) {
        console.log(err);
        throw "Error loading Avatar in updateCustomerAvatars";
      }
    });

    //load the avatars for all mods 
    state.mods.forEach(async m => {
      const avatarLoaded = state.userAvatars.find(a => a.user == m.user.id);
      
      if(avatarLoaded != undefined) {
        return;
      }
      
      try {        
        if (m.avatar == undefined) {
          const avatar = {
            user: m.user.id,
            first_name: m.user.first_name,
            last_name: m.user.last_name,
            avatar: state.defaultAvatarUrl
          }
          commit("addLoadedAvatar", avatar);
        } else {
          const getAvatarOfUser = await this._vm.$directus.getItem("directus_files", m.avatar);
          const avatar = {
            user: m.user.id, 
            first_name: m.user.first_name,
            last_name: m.user.last_name,
            avatar: getAvatarOfUser.data.data.full_url
          }
          commit("addLoadedAvatar", avatar);
        }
      } catch(err) {
        console.log(err);
        throw "Error loading Avatar in updateCustomerAvatars";
      }
    });

    if(!state.customerAvatarsLoaded) commit("setCustomerAvatarsLoaded");
    
  },
  async getDefaultAvatarUrl({commit}) {
    try {
      const response = await this._vm.$directus.getItem("directus_files", state.defaultAvatar);
      commit("setDefaultAvatarUrl", response.data.data.full_url);  
    } catch(err) {
      console.log(err);
      throw "Could not set Default Avatar Url";
    }
  },
  async getUserDialogues({ commit, rootState, dispatch }) {
    if (state.chatMode == "customer") {
      try {
        const filter = {
          filter: {
            kunde: rootState.auth.user.id,
          },
          fields: "*.*"
        };
        const response = await this._vm.$directus.getItems("dialogue", filter);
        if (response.data.length) {
          const userDialogue = [{
            dialog_id: response.data[0].id,
            user_id: rootState.auth.user.id
          }];
          commit("setUserDialogues", userDialogue);
          await dispatch("checkSeenForAll");
          await dispatch("getUserDialogueData");
        }
      } catch (error) {
        console.log(error);
        throw "Error Resolving Customer Dialogue Data";
      }
      return;
    }

    if(state.chatMode == "moderator") {
      try {
        await dispatch("checkSeenForAll");
        await dispatch("getUserDialogueData");        
      } catch(error) {
        console.log(error);
        throw "Error Resolving Dialogue Data for Moderator";
      }
      return;
    }

    try {
      const filter = {
        filter: {
          user_id: rootState.auth.user.id,
        },
        limit: "-1",
      };

      const response = await this._vm.$directus.getItems("dialogue_users", filter);

      if (response.data.length) {
        commit("setUserDialogues", response.data);
        await dispatch("checkSeenForAll");
        await dispatch("getUserDialogueData");
      }
    } catch (error) {
      console.log(error);
      throw "Error Resolving User Dialogue Data";
    }
  },
  async getUserDialogueData({ dispatch, rootState, commit }) {
    console.log("running getUserDialogueData");
    if(state.chatMode == "moderator") {
      result = [];      
      for(let idx = 0; idx < state.dialogues.length; idx++) {
        const messages = state.dialogues[idx].messages.length ? state.dialogues[idx].messages.map((msg) => msg.nachricht_id) : [];        
        const kundeName = `${state.dialogues[idx].kunde.first_name} ${state.dialogues[idx].kunde.last_name}`;
        const subscribers = state.dialogues[idx].subscribers.map(s => s.user_id);
        result.push({
          chat_id: state.dialogues[idx].id,          
          seenby: state.dialogues[idx].seenby,
          kunde: state.dialogues[idx].kunde,
          kundeName,
          messages,
          recipients: [state.dialogues[idx].kunde.id, ...subscribers]
        });
      }
      commit("setActiveChat", result);
      return;
    }
    
    let result = [];
    for (let idx = 0; idx < state.user_dialogues.length; idx++) {
      const dialogue = state.dialogues.find((d) => d.id == state.user_dialogues[idx].dialog_id);
      const kundeName = `${dialogue.kunde.first_name} ${dialogue.kunde.last_name}`;
      const messages = dialogue.messages.length ? dialogue.messages.map((msg) => msg.nachricht_id) : [];
      const filterSubscribers = dialogue.subscribers.filter((u) => u.user_id != rootState.auth.user.id);
      const recipients = filterSubscribers.map((s) => s.user_id);
      await dispatch("getRecipientsOfDialogue", filterSubscribers);
      const chatNotAdded = result.find((c) => c.chat_id == dialogue.id);
      if (chatNotAdded == undefined) {
        result.push({
          chat_id: dialogue.id,
          seenby: dialogue.seenby,
          kunde: dialogue.kunde,
          kundeName,
          messages,
          recipients,
        });
      }
    }
    commit("setActiveChat", result);
  },
  async getSingleDialogueData({ commit, dispatch, rootState }, dialogueId) {
    console.log("running getSingleDialogueData");
    if(state.chatMode == "moderator") {
      const dialogue = state.dialogues.find((d) => d.id == dialogueId);
      const messages = dialogue.messages.map((msg) => msg.nachricht_id);
      const filterSubscribers = dialogue.subscribers.filter((sub) => sub.user_id != rootState.auth.user.id);
      const recipients = filterSubscribers.map((s) => s.user_id);
      await dispatch("getRecipientsOfDialogue", filterSubscribers);
      commit("addSingleActiveChat", {
        chat_id: dialogue.id,
        seenby: dialogue.seenby,
        kunde: dialogue.kunde,
        messages,
        recipients,
      });
      return;
    }
    
    const dialogue = state.dialogues.find((d) => d.id == dialogueId);
    const kundeName = `${dialogue.kunde.first_name} ${dialogue.kunde.last_name}`;
    const messages = dialogue.messages.map((msg) => msg.nachricht_id);
    const filterSubscribers = dialogue.subscribers.filter((sub) => sub.user_id != rootState.auth.user.id);
    const recipients = filterSubscribers.map((s) => s.user_id);
    await dispatch("getRecipientsOfDialogue", filterSubscribers);
    commit("addSingleActiveChat", {
      chat_id: dialogue.id,
      seenby: dialogue.seenby,
      kundeName,
      messages,
      recipients,
    });
  },
  async setUnseenByOthers({ rootState }, dialogueId) {
    try {
      const userId = rootState.auth.user.id;
      const updatePayload = {
        seenby: [userId],
      };
      this._vm.$directus.updateItem("dialogue", dialogueId, updatePayload);
    } catch (error) {
      console.log(error);
      throw "Error setting unseen Status";
    }
  },
  async setSeenByMe(_, payload) {
    try {
      this._vm.$directus.updateItem("dialogue", payload.dialogue, { seenby: payload.seenby });
    } catch (error) {
      console.log(error);
      throw "Error setting seen status";
    }
  },
  async getMessagesOfDialogue(_, messages) {
    let result = [];
    for (let idx = 0; idx < messages.length; idx++) {
      try {
        const response = await this._vm.$directus.getItem("nachrichten", messages[idx]);
        result.push(response.data);
      } catch (error) {
        console.log(error);
        throw "Error loading the messages";
      }
    }
    result.sort((a, b) => new Date(a.created_on) - new Date(b.created_on));
    return result;
  },
  async getRecipientsOfDialogue({ commit }, recipients) {
    let result = [];
    for (let idx = 0; idx < recipients.length; idx++) {
      try {
        const user = await this._vm.$directus.getItem("directus_users", recipients[idx].user_id);
        const result = {
          usr_id: user.data.id,
          user: user.data,
        };
        if (undefined == state.activeChatUsers.find((u) => u.usr_id == user.data.id)) {
          commit("addActiveChatUser", result);
        }
      } catch (error) {
        console.log(error);
        throw "Error loading User Data in chat.js";
      }
    }
    return result;
  },
  async buildUserAddressBook({ rootState, commit, dispatch }) {
    try {
      const responseUsers = await this._vm.$directus.getItems("directus_users", { status: "active", limit: 1000 });
      const users = responseUsers.data.filter((u) => u.role == 3);
      const admins = responseUsers.data.filter((u) => u.role == 1);
      const otherDialogues = state.dialogues.filter((d) => undefined == d.subscribers.find((sub) => sub.user_id == rootState.auth.user.id));

      const result = {
        kunden: users,
        infrabau: admins,
        dialoge: otherDialogues,
      };

      commit("setUserAddressBook", result);
      if (!state.userAvatars.length) await dispatch("loadAvatars", responseUsers.data);
      commit("setReadyAddressBook");
    } catch (error) {
      console.log(error);
      throw "Error building the Addressbook in chat.js";
    }
  },
  async sendChatMail(_, mailData) {
    const token = JSON.parse(localStorage.getItem("directus-sdk-js")).token;
    const url = "https://directus.iam-design.de/public/iam-test/mail";
    const options = {
      headers: {
        Authorization: "bearer " + token,
      },
    };

    console.log("sending mail to chat user");
    console.log("got parameters for mail :");
    console.log(mailData);

    let message = "";
    let subject = "";

    switch(mailData.mode) {
      case "customer": 
        message = `Hallo ${mailData.customer.first_name} ${mailData.customer.last_name},<br />

        <span style='margin-top:20px; margin-bottom:20px;'>
        <br />Sie haben eine neue Nachricht erhalten: <br /> 

        <br/>Bitte melden Sie sich im Portal an um zu Antworten.

        <p><a href='https://www.infrabau-portal.de'>www.infrabau-portal.de</a></p>

        Ihr Infrabau Team
        </span>`;        
        subject = "Sie haben eine neue Nachricht von Infrabau erhalten.";
        break;
      case "subscriber": 
        message = `Hallo, es gibt etwas zu tun.<br />

        <p>Sie wurden dem Chat mit dem Kunden ${mailData.customer.first_name} ${mailData.customer.last_name} zugewiesen.
        <br />Bitte melden Sie sich im Portal an um am Chat teilzunehmen.</p>
        
        Infrabau Chat Mailer`;
        subject = "Sie wurden einem Dialog zugewiesen.";
        break;
      case 'infrabau': 
        message = `Hallo, <br /><br/>
        Sie haben eine Nachricht von ${mailData.customer.first_name} ${mailData.customer.last_name} 
        erhalten: 
        
        <p>${mailData.message}</p>

        Infrabau Chat Mailer
        `;
        subject = "Neue Nachricht über Kundenportal erhalten";
        break;     
    }

    const mailPayload = {
      to: mailData.recipients,
      subject: subject, 
      body: message,
      type: "html"
    }

    console.log("Mail Payload : ");
    console.log(mailPayload);

    try {
      await axios.post(url, mailPayload, options);
    } catch(error) {
      console.log(error);
      throw "Fehler beim Versand der Mail";
    }

  },
  async loadAvatars({ commit }, users) {
    const getDefaultAvatar = await this._vm.$directus.getItem("directus_files", 1192);
    for (let user of users) {
      try {
        if (user.avatar == undefined) {
          user.avatar = getDefaultAvatar.data;
        } else {
          const getAvatar = await this._vm.$directus.getItem("directus_files", user.avatar);
          user.avatar = getAvatar.data;
        }

        commit("addAvatar", {
          usr_id: user.id,
          avatar: user.avatar,
        });

      } catch (error) {
        console.log(error);
        throw "Error loading the Avatars";
      }
    }
  },
  async createDialogue() {
    try {
      const newDialogue = await this._vm.$directus.createItem("dialogue");
      return newDialogue;
    } catch (error) {
      console.log(error);
      throw "Fehler beim Erstellen des Dialogs";
    }
  },
  async assignRecipientsToDialogue(_, relPayload) {
    try {
      const recLength = relPayload.recipients.length;
      for (let i = 0; i < recLength; i++) {
        let createPayload = {
          dialog_id: relPayload.chat,
          user_id: relPayload.recipients[i],
        };
        await this._vm.$directus.createItem("dialogue_users", createPayload);
      }
    } catch (error) {
      console.log(error);
      throw "Fehler beim Zuweisen der Empfänger zu einem Dialog";
    }
  },
  async sendMessage({ dispatch, rootState }, newMessage) {
    console.log("newMEssage in sendMessage is");
    console.log(newMessage);
    try {
      const newMessagePayload = {
        sender: newMessage.sender,
        message: newMessage.message,
      };
      const responseNewMessage = await this._vm.$directus.createItem("nachrichten", newMessagePayload);
      const newRelationPayload = {
        dialogue_id: newMessage.dialogueId,
        nachricht_id: responseNewMessage.data.id,
      };
      await this._vm.$directus.createItem("dialogue_nachrichten", newRelationPayload);
      await dispatch("setUnseenByOthers", newMessage.dialogueId, { seenby: [rootState.auth.user.id] });
      await dispatch("updateSingleDialogue", newMessage.dialogueId);
    } catch (error) {
      console.log(error);
      throw "Fehler beim Erstellen der Nachricht";
    }
  },
  async addDialogue({ commit }, dialogueId) {
    const query = {
      fields: "*.*",
      filter: {
        id: dialogueId,
      },
      limit: "-1",
    };
    const dialogueToAdd = await this._vm.$directus.getItems("dialogue", query);
    commit("addDialogue", dialogueToAdd.data[0]);
  },
  async updateSingleDialogue({ dispatch, commit }, dialogueId) {
    console.log("============= DEBUG ============");
    console.log("running updateSingleDialogue");
    //const currentDialogue = state.dialogues.find(d => d.id == dialogueId);
    try {
      const query = {
        fields: "*.*",
        filter: {
          id: dialogueId,
        },
        limit: "-1",
      };
      const result = await this._vm.$directus.getItems("dialogue", query);
      /*
            const cmp_result = JSON.parse(JSON.stringify(result.data[0].messages));
            const cmp_state = JSON.parse(JSON.stringify(currentDialogue.messages));            
            const diff = cmp_result.filter(f => {
                return cmp_state.find(s => s.id == f.id) === undefined ? true : false;
            });*/
      
      commit("refreshSingleDialogue", result.data[0]);
      await dispatch("getSingleDialogueData", result.data[0].id);
    } catch (error) {
      console.log(error);
      throw "Fehler beim Aktualisieren eines Dialogs";
    }
  },
  async subscribeToDialogue(_, payload) {
    try {
      await this._vm.$directus.createItem("dialogue_users", payload);
    } catch (error) {
      console.log(error);
      throw "Fehler beim Anmelden für Dialog";
    }
  },
  async unsubscribeToDialogue(_, payload) {
    try {
      await this._vm.$directus.deleteItem("dialogue_users", payload);
    } catch(err) {
      console.log(err);
      throw "Fehler beim Abmelden von Dialog";
    }
  }
};

const mutations = {
  chatOn: (state) => {
    state.chatActive = true;
  },
  chatOff: (state) => {
    state.chatActive = false;
  },
  setChatReady: (state) => {
    state.chatReady = true;
  },
  unsetChatReady: (state) => {
    state.chatReady = false;
  },
  setChatInterval: (state, interval) => {
    state.chatInterval = interval;
  },
  setDialogues: (state, dialogues) => {
    state.dialogues = dialogues;
  },
  setUserDialogues: (state, dialogues) => {
    state.user_dialogues = dialogues;
  },
  addActiveChatUser: (state, user) => {
    state.activeChatUsers.push(user);
  },
  setActiveChat: (state, chat) => {
    state.activeChats = chat;
  },
  setUserAddressBook: (state, contacts) => {
    state.userAddressBook = contacts;
  },
  addAvatar: (state, data) => {
    if (state.userAvatars.find((a) => a.usr_id == data.usr_id) == undefined) state.userAvatars.push(data);
  },
  setReadyAddressBook: (state) => (state.addressBookReady = true),
  addSingleActiveChat: (state, chat) => {
    const chatExists = state.activeChats.findIndex((c) => c.chat_id == chat.chat_id);
    if (chatExists == -1) {
      state.activeChats.push(chat);
    } else {
      state.activeChats.splice(chatExists, 1, chat);
    }
  },
  refreshSingleDialogue: (state, dialogue) => {
    const index = state.dialogues.findIndex((d) => d.id == dialogue.id);
    state.dialogues.splice(index, 1, dialogue);
  },
  addDialogue: (state, dialogue) => state.dialogues.push(dialogue),
  setDefaultUnseen: (state) => (state.unseenMessages = 0),
  incrementUnseen: (state) => state.unseenMessages++,
  setMods: (state, mods) => (state.mods = mods),
  unsetMods: (state) => (state.mods = []),
  setChatMode: (state, mode) => (state.chatMode = mode),
  setCustomerDialogue: (state, dialogue) => (state.customerDialogue = dialogue),
  setDefaultAvatarUrl: (state, url) => state.defaultAvatarUrl = url,
  setCustomerAvatarsLoaded: (state) => state.customerAvatarsLoaded = true,
  addLoadedAvatar: (state, avatar) => state.userAvatars.push(avatar),
  setAdmins: (state, admins) => state.admins = admins
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
